import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const Settings = () => {
    return <AdminModulePage moduleKey="settings" />;
};

export default Settings;
